export type NotificationChannel = 'email' | 'push';

export type NotificationType =
  | 'sale_completed'
  | 'product_approved'
  | 'product_rejected'
  | 'product_needs_adjustment'
  | 'withdrawal_approved'
  | 'withdrawal_rejected';

export interface NotificationPreference {
  enabled: boolean;
  channels: NotificationChannel[];
  custom_email: string | null;
}

export interface NotificationSettings {
  enabled: boolean;
  default_channels: NotificationChannel[];
  available_channels: NotificationChannel[];
  has_mobile_token: boolean;
  preferences: Record<NotificationType, NotificationPreference>;
}

export interface NotificationSettingsResponse {
  data: NotificationSettings;
}

export interface UpdateGlobalSettingsPayload {
  enabled: boolean;
  channels: NotificationChannel[];
}

export interface UpdatePreferencePayload {
  enabled: boolean;
  channels: NotificationChannel[];
  custom_email?: string | null;
}

export interface BulkUpdatePayload {
  notifications: Array<{
    type: NotificationType;
    enabled: boolean;
    channels: NotificationChannel[];
    custom_email?: string | null;
  }>;
}

export const NOTIFICATION_CATEGORIES = {
  sales: ['sale_completed'] as NotificationType[],
  products: ['product_approved', 'product_rejected', 'product_needs_adjustment'] as NotificationType[],
  withdrawals: ['withdrawal_approved', 'withdrawal_rejected'] as NotificationType[],
};

export const NOTIFICATION_TYPE_LABELS: Record<NotificationType, string> = {
  sale_completed: 'notification_sale_completed',
  product_approved: 'notification_product_approved',
  product_rejected: 'notification_product_rejected',
  product_needs_adjustment: 'notification_product_needs_adjustment',
  withdrawal_approved: 'notification_withdrawal_approved',
  withdrawal_rejected: 'notification_withdrawal_rejected',
};
